import React, { Component } from 'react'
import Table from "../../../../components/UI/Table/Table";
import { checkMasterDataKeyId, setMasterDataKey } from '../helper';
import AutoSuggest from '../../../../components/ReusableComponents/AutoSuggest/index';
import { Input } from "reactstrap";
// import Autosuggest from 'react-autosuggest';


let that;
const tableColumns = [
    {
        Header: "Name",
        id: "displayName",
        accessor: d => <div title={d.displayName}>{d.displayName}</div>
        // <div title={d.counterpartyName}>{d.counterpartyName}</div>
    },
    {
        Header: "Element Name",
        id: 'elementName',
        accessor: "elementName"
    },
    {
        Header: "Element Data Type",
        id: "elementDataType",
        accessor: d => <div title={d.elementDataType}>{d.elementDataType}</div>
        // <div title={d.counterpartyName}>{d.counterpartyName}</div>
    },
    {
        Header: "Data Key",
        id: "masterDataValues",
        accessor: d => that.setAutosuggest(d)

    },
    {
        Header: "API Key",
        id: "apiKeyName",
        accessor: d => <Input type="text" value ={d.apiKeyName == null ? "" : d.apiKeyName } name="apiKeyName" id={`apiKeyName_${d.masterDataKeyId}`} onChange={(e) => that.changeAPIName(e, d)} disabled = {true} />

    }

];
{/* <select className="form-control" defaultValue={d.masterDataKeyId} onChange={(event) => that.handleMasterDataChange(event, d)}>
                <option value=''>Select</option>
                {(d.elementDataType === 'NUMERIC') ? d.masterDataValuesNumeric.map(p => {
                    return (<option key={p.id} value={p.id}>{p.name}</option>)
                }) : d.masterDataValuesAlphaNumeric.map(p => {
                    return (<option key={p.id} value={p.id}>{p.name}</option>)
                })}
            </select> */}
class SectionTemplateTableView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.tasks,
            rowData: [],
            inputProps: {
                value: '',
                onChange: this.onChange,
                disabled: false,
                className: "form-control"
            }
        };
        that = this;
    }
    componentDidUpdate(prevProps) {
        if (this.props.tasks !== prevProps.tasks) {
            this.setState({
                data: this.props.tasks
            })
        }
    }
    getDefualtValue = (rowdata) => {
        if (rowdata.elementDataType === 'ALPHANUMERIC') {
            return rowdata.masterDataValuesAlphaNumeric.find(resultData => (resultData.id === rowdata.masterDataKeyId) ? resultData : null)
        } else {
            return rowdata.masterDataValuesNumeric.find(resultData => (resultData.id === rowdata.masterDataKeyId) ? resultData : null)
        }
    }
    setAutosuggest = (rowdata) => {
        this.setState({
            rowData: rowdata
        });
        const inputProps = {
            value: this.getDefualtValue(rowdata),
            onChange: this.onChange,
            disabled: false,
            className: "form-control"
        }
        return <div className='table-autosuggest'>
            <AutoSuggest
                id='dataMappingSearch'
                placeholder="Search Risk Factors"
                onChange={this.handleNonFinancialChange}
                searchCallback={this.handleMasterDataChange}
                inputProps={inputProps}
                rowName={rowdata.elementName}
                searchType="riskFactorSearch"
                resultData={(rowdata.elementDataType === 'ALPHANUMERIC') ? rowdata.masterDataValuesAlphaNumeric : rowdata.masterDataValuesNumeric}
            />
        </div>
    }
    handleMasterDataChange = (data, id, rowName) => {
        const tempRowdata = setMasterDataKey(rowName, this.props.mappingData, data);
        this.setState({
            rowData: tempRowdata
        })
        const tempData = checkMasterDataKeyId(tempRowdata, data)
        this.props.tableCallback(tempData)
    }

    changeAPIName = (e, data) => {
        e.preventDefault();
        let tempData = {...data, "apiKeyName" : e.target.value}
        this.props.tableCallback(tempData);
        this.setState({"apiKeyName" : e.target.value })
    }
    
    render() {
        return (
            <Table
                data={this.props.mappingData}
                columns={tableColumns}
                defaultPageSize={(this.props.mappingData) ? this.props.mappingData.length : 0}
                showPagination={false}
                showPaginationTop={false}
                showPaginationBottom={true}
                loading={this.props.loading}
            />
        )
    }
}

export default SectionTemplateTableView